import component from './Page404.vue'
export default component
